import { jwtDecode } from "jwt-decode";
import storage from "./storage";
import moment from "moment";
import { v5 as uuidv5 } from 'uuid';


/**
 * Retrieves the decoded user information from the JWT token.
 * @returns {User|null} The decoded user information, or null if no token is found.
 */
export const getDecodedToken = (): any|null => {
    const token: string|null = storage.getToken();
    if(!token) return null;
    const decoded: any = jwtDecode(token);
    return (decoded as any).data as any;
}

/**
 * Checks if the JWT token is about to expire within the next 2 minutes.
 * @returns {boolean} True if the token is about to expire, otherwise false.
 */
export const isTokenAboutToExpire = (): boolean => {
    const token: string|null = storage.getToken();
    if(!token) return false;
    const decoded: any = jwtDecode(token);
    const expirationTime = decoded.exp * 1000; // Convert expiration time to milliseconds
        
    const dateNow = moment().add(2, "minute").valueOf();
    return expirationTime < dateNow;
}

export const isExpiredTime = (exp: number) => {
    return (Date.now() >= exp * 1000);
}

// Getting Formik Schema Required Validation
export const isFieldRequired = (schema: any, controlId: string): boolean =>
    schema?.fields?.[controlId]?.tests?.some(
        (test: any) => test?.OPTIONS?.name === 'required'
    );



// Maps an HTTP method to the same colored-pill classes used for the method column in
// Scan History > Discovered URLs, so the method badge looks identical wherever it's shown
// (e.g. this dropdown's colorized labels).
export const getHttpMethodBadgeClass = (method: any): string => {
    switch (method?.toUpperCase?.()) {
        case "GET":
            return "bg-custom-success-subtle text-custom-success border-success border-opacity-25";
        case "POST":
            return "bg-custom-risk-medium-subtle text-custom-risk-medium border-custom-risk-medium-light";
        case "DELETE":
            return "bg-custom-risk-high-subtle text-custom-risk-high border-custom-risk-high-light";
        case "PUT":
            return "bg-custom-risk-low-subtle text-custom-risk-low border-custom-risk-low-light";
        default:
            return "bg-custom-risk-false-subtle text-custom-risk-false border-custom-risk-false-light";
    }
};

export const backToTab = (id: any) => {
    const tabElement: any = document.querySelector(`#${id}`);
    tabElement.click();
}

export function getDeviceID(email: any) {
    let clientId;
    let currentTime = new Date().getTime();
    const clientStorage = email || 'mfa_client_id';
    const sessionId = localStorage.getItem(clientStorage);
    if (sessionId) {
      clientId = sessionId;
    } else {
      // Use a fixed namespace UUID (any valid UUID string)
      const NAMESPACE = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
      const data = [
        navigator.userAgent,
        navigator.language,
        window.screen.width,
        window.screen.height,
        window.screen.colorDepth,
        email,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        currentTime
      ].join('-');
      clientId = uuidv5(data, NAMESPACE);
      localStorage.setItem(clientStorage, clientId);
    }
    return clientId;
}

export const getPast12Months = () => {
  const months = [];

  for (let i = 11; i >= 0; i--) {
    const month = moment().subtract(i, "months");

    months.push({
      monthLabel: month.format("MMM YYYY"),
      startDate: month.startOf("month").format("YYYY-MM-DD"),
      endDate: month.endOf("month").format("YYYY-MM-DD"),
    });
  }

  return months;
};